import { render } from "./MyTable.vue?vue&type=template&id=679382ae&scoped=true"
import script from "./MyTable.vue?vue&type=script&lang=js"
export * from "./MyTable.vue?vue&type=script&lang=js"

import "./MyTable.vue?vue&type=style&index=0&id=679382ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679382ae"]])

export default __exports__